import gql from 'graphql-tag';

const query = gql`
	query {
		getAllMenu {
			status
			errorMessage
			results {
				id
				menuName
				isEnable
				subMenus {
					id
					name
					isEnable
				}
			}
		}
	}
`;

export default function fetchMenusAndSubmenus() {
	return async (dispatch, getState, { client }) => {
		try {
			const { data } = await client.query({
				query,
				fetchPolicy: 'network-only'
			});

			if (data && data.getAllMenu && data.getAllMenu.status === 200) {
				return data.getAllMenu.results;
			}
			return [];
		} catch (err) {
			console.error(err);
			return [];
		}
	}
};
